var map = {
	"./B1.svg": 2571,
	"./B10.svg": 44881,
	"./B11.svg": 46848,
	"./B12.svg": 91507,
	"./B13.svg": 4130,
	"./B14.svg": 16301,
	"./B15.svg": 85292,
	"./B16.svg": 47967,
	"./B17.svg": 33326,
	"./B18.svg": 63113,
	"./B19.svg": 37752,
	"./B2.svg": 63736,
	"./B20.svg": 41304,
	"./B21.svg": 16809,
	"./B22.svg": 91226,
	"./B23.svg": 96491,
	"./B24.svg": 31780,
	"./B25.svg": 9797,
	"./B26.svg": 89926,
	"./B27.svg": 36375,
	"./B28.svg": 31168,
	"./B29.svg": 71729,
	"./B3.svg": 98601,
	"./B30.svg": 85691,
	"./B31.svg": 51498,
	"./B4.svg": 96006,
	"./B5.svg": 83543,
	"./B6.svg": 40420,
	"./B7.svg": 95141,
	"./B8.svg": 16322,
	"./B9.svg": 78963,
	"./G1.svg": 83216,
	"./G10.svg": 81024,
	"./G11.svg": 37937,
	"./G12.svg": 57538,
	"./G13.svg": 71763,
	"./G14.svg": 31372,
	"./G15.svg": 66829,
	"./G16.svg": 33729,
	"./G17.svg": 94047,
	"./G18.svg": 7512,
	"./G19.svg": 66665,
	"./G2.svg": 49315,
	"./G20.svg": 94649,
	"./G21.svg": 82280,
	"./G22.svg": 14171,
	"./G23.svg": 45354,
	"./G24.svg": 74453,
	"./G25.svg": 36468,
	"./G26.svg": 1031,
	"./G27.svg": 37814,
	"./G28.svg": 95233,
	"./G29.svg": 4112,
	"./G3.svg": 99922,
	"./G30.svg": 31406,
	"./G4.svg": 33853,
	"./G5.svg": 21660,
	"./G6.svg": 84335,
	"./G7.svg": 21758,
	"./G8.svg": 7929,
	"./G9.svg": 26184,
	"./default.svg": 51179,
	"./default/B14.svg": 77111,
	"./default/B23.svg": 82133,
	"./default/B25.svg": 21851,
	"./default/B4.svg": 55540,
	"./default/G2.svg": 71261,
	"./default/default.svg": 65173
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91326;